import { inject } from '@angular/core';
import { ValueAccessorDirective } from './p-value-accessor.directive';

export function injectValueAccessor<T>(): ValueAccessorDirective<T> {
    return inject(ValueAccessorDirective);
}
